<template>
  <div class="pdf-document" v-bind:style="fieldStyle">
    <v-row justify="center">
      <v-col align-self="center" cols="2" sm="2" md="2" >
        <p style="margin:0px;">{{ currentPage }} / {{ maxPage }}</p>
      </v-col>
      <v-col cols="1" sm="1" md="1" >
        <v-btn block color="white" class="black--text" v-on:click="prev" >&lt;</v-btn>
      </v-col>
      <v-col cols="1" sm="1" md="1" >
        <v-btn block color="white" class="black--text" v-on:click="next" >&gt;</v-btn>
      </v-col>
    </v-row>
    <div style="margin: 10px 50px;">
        <div v-bind:style="draggableAreaStyle">
          <v-overlay :absolute="true" :value="isLoading">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
          <contract-pdf-page-component
          v-for="page in pages"
          v-bind="{page, scale}"
          :key="page.pageNumber"
          style="position:absolute"
          :setFieldStyle="setFieldStyle"
          />
          <template v-if="Object.entries(currentInputs).length > 0 && draggableAreaStyle != null">
            <template
              v-for="(pageData,i) in Object.entries(currentInputs)"
              >
              <draggable-input-component
                v-for="(inputData,index) in Object.entries(pageData[1])"
                :key="`${i}-${index}-${currentPage}`"
                :type="inputData[1].type"
                :destinations="destinations"
                :x="inputData[1].x"
                :y="inputData[1].y"
                :value="inputData[1].value"
                :sealText="inputData[1].sealText"
                :direction="inputData[1].direction"
                :label="inputData[1].label"
                :defaultValue="inputData[1].defaultValue"
                :destinationId="inputData[1].destinationId"
                :required="inputData[1].required"
                :objectId="inputData[0]"
                :page="pageData[0]"
                :pdfId="pdfId"
                :color="inputData[1].color"
                :colorsIdMap="colorsIdMap"
                :bgColorsIdMap="bgColorsIdMap"
                :createUserId="createUserId"
                :selectItems="inputData[1].selectItems"
                :pdfWidth="pdfWidth"
                :pdfHeight="pdfHeight"
                v-show="isShowElement(pageData[0]) && !inputData[1].deleted"
                @closeElement="closeElement"
                @updateInputDetail="updateInputDetail"
              >
              </draggable-input-component>
            </template>
          </template>
        </div>
    </div>
  </div>
</template>

<script>
// import range from 'lodash/range';
import * as pdfjsLib from 'pdfjs-dist';
import "pdfjs-dist/web/pdf_viewer.css";
import { imageMixin } from '../../mixins/imageMixin.js';
export default {
  props: ['url', 'scale', 'pdfId', 'destinations', 'colorsIdMap','bgColorsIdMap', 'createUserId', 'addInputs', 'maxObjId'],
  data() {
    return {
      pdf: undefined,
      pages: [],
      maxPage: 1,
      currentPage: 1,
      isLoading: false,
      textMinWidth: "200px",
      textMinHeight: "60px",
      textMaxWidth: 200,
      textMaxHeight: 60,
      checkboxMaxWidth: 40,
      checkboxMaxHeight: 40,
      sealMaxWidth: 40,
      sealMaxHeight: 40,
      currentInputs: {}, // 画面描画用の入力項目
      maxObjectId: 0,
      fieldStyle: { width: '700px', height: '800px' },
      draggableAreaStyle: null,
      pdfWidth: 0,
      pdfHeight: 0,
      times: 2,
    };
  },
  created() {
    pdfjsLib.GlobalWorkerOptions.workerSrc = "/documents/js/pdf.worker.js";
    this.fetchPDF();
    // 入力項目を配置
    // 入力項目のオブジェクトIDを設定
    this.maxObjectId = this.maxObjId;
    this.inputs = Object.assign({}, this.addInputs);
    this.currentInputs = Object.assign({}, this.addInputs);
  },

  methods: {
    setFieldStyle(width, height) {
      let tempWidth = Math.floor(width/this.times)
      let tempHeight = Math.floor(height/this.times)
      this.fieldStyle = { width: (tempWidth + 100) + 'px', height: (tempHeight + 100) + 'px' };
      this.draggableAreaStyle = { width: tempWidth + 'px', height: tempHeight + 'px', margin: '0 75px;' };
      this.pdfWidth = tempWidth
      this.pdfHeight = tempHeight
      let widths = [];
      widths[this.pdfId] = tempWidth;
      this.updatePdfWidth(widths);
      this.$nextTick(() => {
          window.dispatchEvent(new Event('resize'))
      })
    },
    fetchPDF: async function () {
      this.setLoading(true);
      this.$emit('loading', true);
      let loadingTask = pdfjsLib.getDocument({
          url: this.url,
          cMapUrl: '/documents/cmaps/',
          cMapPacked: true,
      });
      let loadpdf = await loadingTask.promise;
      this.pdf = loadpdf;
      this.maxPage = loadpdf.numPages;
      this.setLoading(false);
      this.$emit('loading', false);
      let nums = [];
      nums[this.pdfId] = this.maxPage;
      this.updateMaxPages(nums);
    },
    fetchNewPDF: async function () {
      this.firstPage();
      this.fetchPDF();
    },
    isFirst: function () {
      return this.currentPage <= 1; 
    },
    isEnd: function () {
      return this.currentPage >= this.maxPage;
    },
    prev: function () {
      if (this.currentPage > 1) {
        this.currentPage -= 1;
      }
    },
    next: function () {
      if (this.currentPage < this.maxPage) {
        this.currentPage += 1;
      }
    },
    firstPage: function () {
      this.currentPage = 1;
    },
    changePage: function(pageNum) {
      this.currentPage = pageNum;
      this.$nextTick(function() {
        this.$emit('loading', false);  
      });
    },
    setLoading: function (loading) {
        this.isLoading = loading;
    },
    addText: function () {
        this.addElement({
          type: 'text',
          destinationId: this.createUserId,
          label: '',
          required: false,
          defaultValue: false,
          x: 0,
          y: 0,
          value: '',
          color: 'blue',
          deleted: false,
        });
    },
    addSelect: function () {
        this.addElement({
          type: 'select',
          destinationId: this.createUserId,
          label: '',
          required: false,
          defaultValue: false,
          x: 0,
          y: 0,
          value: '',
          color: 'blue',
          deleted: false,
          selectItems: [],
        });
    },
    addCheckbox: function () {
        this.addElement({
          type: 'checkbox',
          destinationId: this.createUserId,
          label: '',
          required: false,
          defaultValue: false,
          x: 0,
          y: 0,
          value: '',
          color: 'blue',
          deleted: false,
        });
    },
    addSeal: function () {
        this.addElement({
          type: 'seal',
          destinationId: this.createUserId,
          label: '',
          required: false,
          defaultValue: false,
          x: 0,
          y: 0,
          value: '',
          color: 'blue',
          deleted: false,
        });
    },
    addElement: function (inputData) {
        this.maxObjectId++;
        if (!(this.currentPage in this.inputs)) {
          this.inputs[this.currentPage] = new Object();
        }
        this.inputs[this.currentPage][this.maxObjectId] = inputData;
        this.currentInputs = Object.assign({}, this.inputs);
        this.updateInput(this.currentPage, this.maxObjectId, inputData);
    },
    isShowElement: function (page) {
      return this.currentPage === Number(page);
    },
    closeElement: function (pdfId, page, objectId) {
      this.inputs[page][objectId].deleted = true;
      this.currentInputs = Object.assign({}, this.inputs);
      this.updateInput(page, objectId, this.inputs[page][objectId]);
    },
    updateInput: function (page, objectId, value) {
      this.$emit("updateInput", this.pdfId, page, objectId, value);
    },
    updateMaxPages: function (maxPages) {
      this.$emit("updateMaxPages", maxPages);
    },
    updatePdfWidth: function (widths) {
      this.$emit("updatePdfWidth", widths);
    },
    updateInputDetail: function (page, objectId, type, destinationId, value, label, require, defaultValue, x, y, deleted, color, selectItems = [], sealText, direction) {
      let image = "";
      if(value && (type == "text" || type == "select")){
          image = this.strTo64Base(value);
      }
      this.inputs[page][objectId] = {
          type: type,
          destinationId: destinationId,
          label: label,
          required: require,
          defaultValue: defaultValue,
          x: x,
          y: y,
          value: value,
          color: color,
          deleted: deleted,
          selectItems: selectItems,
          sealText: sealText,
          direction: direction,
          image:image,
      };
      this.currentInputs = Object.assign({}, this.inputs);
      this.updateInput(page, objectId, this.inputs[page][objectId]);
    }
  },
  mixins:[imageMixin],
  watch: {
    pdf(pdf) {
      this.pages = [];
      Promise.all([pdf.getPage(this.currentPage)]).
        then(pages => (this.pages = pages));
    },
    currentPage(pageNum) {
      // ページ切り替えの際に埋め込み画像等が消える問題があったため、保持しているPDFデータを都度読み込み直す
      var my = this;
      this.pdf.getData().then(async function(arrayBuffer) {
        my.setLoading(true);
        my.$emit('loading', true);
        let loadingTask = pdfjsLib.getDocument({
            data: arrayBuffer,
            cMapUrl: '/documents/cmaps/',
            cMapPacked: true,
        });
        my.pdf = await loadingTask.promise;
        await my.pdf.getPage(pageNum);
        my.setLoading(false);
        my.$emit('loading', false);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*!
    * "Noto Sans JP" is lisenced under the SIL Open Font License 1.1
    * http://fonts.googleapis.com
    * https://www.google.com/fonts/attribution
    * http://scripts.sil.org/OFL
    */
    @font-face {
        font-family: 'Noto Sans JP', sans-serif;
        src: url('/documents/fonts/NotoSansJP-Regular.otf');
    }
    .circle{
      display: inline-block;
      width: 40px;
      height: 40px;
      text-align:center;
      line-height: 40px;
      border-radius: 50%;
      border: solid 3px blue;
    }

    .close-btn {
      position: absolute;
      top: -12px;
      right: -12px;
      width: 24px;
      height: 24px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .move-btn {
      position: absolute;
      bottom: -12px;
      right: -12px;
      width: 24px;
      height: 24px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .edit-btn {
      position: absolute;
      bottom: -12px;
      right: 14px;
      width: 24px;
      height: 24px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0px 2px 1px 0 rgb(0 0 0 / 10%);
    }

    .text-drag-form {
      border: none;
    }

    .checkbox-drag-form {
    }

    .seal-drag-form {
    }
</style>
